import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFBolus = {
  volume: number;
  extendedDuration: number;
  calculationRecordOffset: number;
  immediateDuration: number;
};

export const IBF_BOLUS = {
  value: 0x0004,
  name: "IBF_BOLUS",
  size: 10,
  parse: (record): IBFBolus => {
    const volume = record.nextUInt32LE() / 100.0;
    let extendedDurationMinutes = record.nextUInt16LE();
    const calculationRecordOffset = record.nextInt16LE();
    const immediateDurationSeconds = record.nextUInt16LE();
    if (extendedDurationMinutes === 65535) {
      /*
      this occurs if an extended bolus is programmed but the bolus is interrupted
      before any of the extended portion is delivered!
       */
      extendedDurationMinutes = 0;
    }
    const extendedDuration = extendedDurationMinutes * 60 * 1000;
    const immediateDuration = immediateDurationSeconds * 1000;
    return {
      volume,
      extendedDuration,
      calculationRecordOffset,
      immediateDuration,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFBolus>;
